import { SaveAlt, Search } from "@material-ui/icons";
import { Fab, Grid, TextField, Tooltip } from "@mui/material";
import Select from "components/select/Select";
import { useGetListPbxType } from "service/query/business-management.query";
import { getSelectFieldProps, getTextFieldProps } from "ultis/form";

const BusinessFilter = ({ formik, onClickDownload }) => {
  const { data: listPbxType } = useGetListPbxType();

  return (
    <form onSubmit={formik.handleSubmit}>
      <Grid container spacing={2}>
        <Grid item xs={3}>
          <Select
            {...getSelectFieldProps(formik, "pbxType")}
            label="Loại tổng đài"
            showAllOption
            options={listPbxType?.map((item) => ({
              label: item.name,
              value: item.pbxType,
            }))}
          />
        </Grid>
        <Grid item xs={3}>
          <TextField
            {...getTextFieldProps(formik, "name")}
            label="Tên nghiệp vụ"
          />
        </Grid>
        <Grid item xs={3}>
          <TextField
            {...getTextFieldProps(formik, "contractCode")}
            label="Mã hợp đồng"
          />
        </Grid>
        <Grid item xs={2}>
          <Tooltip title="Tìm kiếm" disableFocusListener>
            <Fab
              color="primary"
              aria-label="Search"
              type="submit"
              sx={{ mr: 1 }}>
              <Search />
            </Fab>
          </Tooltip>
          <Tooltip title="Tải xuống tất cả nghiệp vụ">
            <Fab color="primary" aria-label="export" onClick={onClickDownload}>
              <SaveAlt />
            </Fab>
          </Tooltip>
        </Grid>
      </Grid>
    </form>
  );
};

export default BusinessFilter;
